import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo">
              <img src="/images/logo.png" alt="Island Mobile Marine Service" className="footer-logo-image" />
            </Link>
            <p>Mobile, on-site boat repair and maintenance from a marine technician you can actually reach.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <nav className="footer-nav">
              <Link to="/">Home</Link>
              <Link to="/services">Services</Link>
              <Link to="/booking">Book Service</Link>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
            </nav>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            <div className="footer-contact">
              <p><strong>Jeremy Willoughby</strong></p>
              <p>Marine Technician</p>
              <a href="tel:8503230769">📞 850-323-0769</a>
              <a href="mailto:Jeremy@islandmobilemarine.com">✉️ Jeremy@islandmobilemarine.com</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Island Mobile Marine Service. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
